import { Pipe, PipeTransform } from '@angular/core';

import { ITypeGroup } from '../../prisma-xs/models/prisma-xs.model';
import { IArticle } from '../../prisma-xs/models/article.model';
import { getSmallestArticle } from '../../enclosure/helpers/pragma.helper';

@Pipe({
    name: 'smallestArticleGroup',
    standalone: false
})
export class SmallestArticleGroupPipe implements PipeTransform {
  transform(group: ITypeGroup): IArticle {
    return getSmallestArticle(group.articles);
  }
}
